export enum NotificationTypesEnum {
  CancelConsultationPatient = 'cancel_consultation_patient',
  NewDiscussionMessage = 'new_discussion_message',
  CreateConsultation = 'create_consultation',
  ConsultationSummary = 'consultation_summary',
}
